export default "__VITE_ASSET__ComOEiou__"